import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { SectionProgressState } from "./SectionBar";

interface SectionBarItemProps {
    name: string;
    state: SectionProgressState;
    icon: IconDefinition;
    sectionDescription?: string;
    isActive?: boolean;
    index: number;
}

export const SectionBarItem = ({
    name,
    state,
    icon,
    sectionDescription,
    isActive = false,
    index
}: SectionBarItemProps) => {
    let iconElement;
    let nameClassName = "";
    let descriptionClassName = "";

    switch (state) {
        case SectionProgressState.Completed:
            iconElement = (
                <FontAwesomeIcon
                    icon={solid("check-circle")}
                    className="section-bar__item__title__icon--completed"
                />
            );
            nameClassName = "section-bar__item__title__name--completed";
            descriptionClassName = "section-bar__item__description--completed";
            break;

        case SectionProgressState.NotStarted:
            iconElement = (
                <FontAwesomeIcon
                    icon={icon as IconProp}
                    className="section-bar__item__title__icon--not-started"
                />
            );
            nameClassName = "section-bar__item__title__name--not-started";
            descriptionClassName = "section-bar__item__description--not-started";
            break;

        case SectionProgressState.InProgress:
            iconElement = (
                <FontAwesomeIcon
                    icon={solid("circle")}
                    className="section-bar__item__title__icon--inprogress"
                />
            );
            nameClassName = "section-bar__item__title__name--inprogress";
            descriptionClassName = "section-bar__item__description--inprogress";
            break;
    }

    return (
        <li className={`section-bar__item ${isActive ? 'section-bar__item--active' : ''}`}>
            <span className="section-bar__item__title">
                <span className={`section-bar__item__title__icon`}>{iconElement}</span>
                <span className={`section-bar__item__title__name ${nameClassName}`}>{`${index}. ${name}`}</span>
            </span>
            <span className={`section-bar__item__description ${descriptionClassName}`}>{sectionDescription}</span>
        </li>
    );
};